import { motion } from "framer-motion";
import { useMemo } from "react";

const Snowfall = () => {
  const snowflakes = useMemo(() => {
    return Array.from({ length: 50 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      size: Math.random() * 8 + 4,
      duration: Math.random() * 15 + 10,
      delay: Math.random() * 5,
      drift: Math.random() * 30 - 15,
    }));
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-10">
      {snowflakes.map((flake) => (
        <motion.div
          key={flake.id}
          className="absolute rounded-full bg-background/60"
          style={{
            left: `${flake.x}%`,
            width: flake.size,
            height: flake.size,
            top: -20,
          }}
          animate={{
            y: ["0vh", "110vh"],
            x: [0, flake.drift, 0, -flake.drift, 0],
          }}
          transition={{
            y: {
              duration: flake.duration,
              repeat: Infinity,
              ease: "linear",
              delay: flake.delay,
            },
            x: {
              duration: flake.duration / 2,
              repeat: Infinity,
              ease: "easeInOut",
              delay: flake.delay,
            },
          }}
        />
      ))}
    </div>
  );
};

export default Snowfall;
